import { render } from "./MaterialSelect.vue?vue&type=template&id=74c3d81c&scoped=true"
import script from "./MaterialSelect.vue?vue&type=script&lang=js"
export * from "./MaterialSelect.vue?vue&type=script&lang=js"

import "./MaterialSelect.vue?vue&type=style&index=0&id=74c3d81c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c3d81c"],['__file',"src/ui-components/MaterialSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74c3d81c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74c3d81c', __exports__)) {
    api.reload('74c3d81c', __exports__)
  }
  
  module.hot.accept("./MaterialSelect.vue?vue&type=template&id=74c3d81c&scoped=true", () => {
    api.rerender('74c3d81c', render)
  })

}


export default __exports__